import { observable, action, computed } from 'mobx';
import { IFilters } from '~domain/entities/StoresFilter';
import { Config, IConfig } from '~domain/entities/Config';
import { IActiveFilters } from '~api/Interfaces';
import { IMultiOptionFilters, IBooleanFilters } from '~interfaces/IStoresInterfaces';

export class FiltersRepository {
    @observable public availableFilters: IFilters;
    @observable public multiOptionFilters: IMultiOptionFilters = {};
    @observable public booleanFilters: IBooleanFilters = {};
    @observable public filtersEnabled: boolean = false;
    @observable public openNowEnabled: boolean = false;
    @observable public servicesAvailableFilter: boolean = false;
    @observable public inStorePickupFilter: boolean = false;

    constructor(configService: Config) {
        const config = configService.config;
        const featureFlags = config && config.featureFlags;
        this.openNowEnabled = featureFlags && featureFlags.openNow;
        this.filtersEnabled = featureFlags && featureFlags.enableFilters;
        this.initializeFilters(config);
    }

    @action
    private initializeFilters = (config: IConfig) => {
        this.booleanFilters = {
            ...this.booleanFilters,
            inStorePickup: false,
            oabServices: false,
            ...(this.openNowEnabled && { openNow: false })
        };

        if (this.filtersEnabled) {
            this.availableFilters = (config && config.filters) || [];
            this.availableFilters.forEach((filter) => (this.multiOptionFilters[filter.name] = []));
        }
    };

    @action
    public toggleMultiOptionFilter = (value: string) => {
        const [filterType, filterOption] = value.split('-');
        const isActiveFilter = this.multiOptionFilters[filterType].includes(filterOption);

        if (isActiveFilter) {
            const slicedFilters = this.multiOptionFilters[filterType].filter(
                (filter) => filter !== filterOption
            );
            this.multiOptionFilters[filterType] = slicedFilters;
        } else {
            const selectedFilters = [...this.multiOptionFilters[filterType], filterOption];
            this.multiOptionFilters[filterType] = selectedFilters;
        }
    };

    @action toggleBooleanFilter = (filterType: string) => {
        this.booleanFilters[filterType] = !this.booleanFilters[filterType];
    };

    @computed
    public get activeFilters(): IActiveFilters {
        return {
            ...this.multiOptionFilters,
            ...this.booleanFilters
        };
    }
}
